// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2k8MU","title":"Images45_title__12DtM","images":"Images45_images__nKwfL"};